import React, { useEffect } from "react";
import { getIcons } from "../Constant/Constant";

const ConfirmationModal = ({
  showModal,
  icon,
  title,
  message,
  onConfirm,
  confirmText = "Confirm",
  onCancel,
  content,
  loading = false,
  additionalProp = true,
  
}) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && showModal) {
        onCancel();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onCancel, showModal]);

  const icons = getIcons();

  if (!showModal) return null;
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white  p-6  flex flex-col justify-center rounded-lg shadow-lg w-[35%] text-center">
        <div className="flex items-center justify-center mb-4">
          {icon ? (
            <img src={icon} className="w-14 " />
          ) : (
            <img src={icons?.confirmationWarning} className="w-14" />
          )}
        </div>

        <h2 className="text-xl font-semibold" >{title}</h2>

        <p className="mt-2 text-lg text-gray-600">{message}</p>

        <div className="my-4">
          {content}
        </div>

{additionalProp && (
  <div className="mt-4 flex justify-center space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
          >
            Cancel
          </button>
          <button
          disabled={loading}
            onClick={onConfirm}
            className={`flex px-4 py-2 items-center justify-center text-center  gap-2  h-[50px] 
            bg-customGreen text-white rounded-[10px] font-medium 
            transition duration-200
            ${loading ? 'bg-gray-400 cursor-not-allowed' : ''}`}
           
          >
            {confirmText}
          </button>
        </div>
)}
        
      </div>
    </div>
  );
};

export default ConfirmationModal;
